<template>
  <header v-show="isShowCzh">
    <div class="flex ljb-item title">
      <!--<img :src="logo" class="logo"/>-->
      <img
        :src="channelData.logo">
    </div>
  </header>
</template>

<script>
import {mapState} from 'vuex'
const namespace = 'User'

export default {
  name: 'LjbHeader',
  // props: {
  //   isShowCzh: {
  //     type: Boolean,
  //     default: false
  //   }
  // },

  computed: {
    ...mapState(namespace, ['userInfo', 'showLogin']),
    ...mapState('Channel', ['channelData']),
    isShowCzh () {
      return this.channelData.channelCode === 'gzh'
    }
  },
  methods: {
    onClick: function () {
      this.$store.commit('User/setShowLogin', true)
    },
    showPopuAside: function () {
      this.$emit('showPopuAside')
    }
  }

}
</script>

<style scoped lang="scss">

  .right-item {
      height: 52px;
  }
  .icon-item {
    @extend .flex;
    @extend .double-center;
    padding: 0 $padding;
  }

  .title {
    justify-content: space-between;
    .logo {
      height: 52px;
      width: 192px;
  }
    .logo-new {
      height: 52px;
      width: 252px;
    }
    .xr-icon {
      height: 42px;
      width: 42px;
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/LjbHeader.vue